import { useEffect } from "react";
import { motion } from "framer-motion";
import { EASE } from "../components/landing/Reveal";

const PageShell = ({ children, pad = true, title }) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Me 1st Fitness & Coaching — Red Deer, AB`;
    }
  }, [title]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: EASE }}
      className={pad ? "pt-8" : ""}
    >
      {children}
    </motion.div>
  );
};

export default PageShell;
